import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Hero.module.css";
import { IMAGES } from "../../../data/images";
import ConsultationOverlay from "../../layout/ConsultationOverlay";
import { Parallax, ParallaxBg } from "../../animations";

const Hero = () => {
  const [showOverlay, setShowOverlay] = useState(false);
  const navigate = useNavigate();

  return (
    <div className={styles.hero}>
      <ParallaxBg />
      <div className={styles.heroInner}>
        <div className={styles.heroLeft}>
          <span className={`${styles.badge} hero-anim-badge`}>
            ✈️ Trusted by 5,000+ students since 2018
          </span>
          <h1 id="hero-heading" className="hero-anim-title">
            Your Gateway to World-Class Education Abroad
          </h1>
          <p className="hero-anim-text">
            From university admissions and visa assistance to scholarships,
            accommodation, and flights — Ever Sky Overseas provides end-to-end
            support for Indian students pursuing their dreams abroad.
          </p>
          <div className="flex gap-3 flex-wrap justify-center lg:justify-start hero-anim-cta">
            <button className={styles.heroButton} onClick={() => setShowOverlay(true)}>
              Get Free Consultation
            </button>
            <button
              className={styles.heroButtonOutline}
              onClick={() => navigate("/pricing")}
            >
              View Pricing
            </button>
          </div>
        </div>
        <div className={`${styles.heroRight} hero-anim-image`}>
          <Parallax speed={0.2} scale>
            <img
              src={IMAGES.homepageHero}
              alt="Students studying abroad"
              className={styles.heroImage}
            />
          </Parallax>
        </div>
      </div>
      {showOverlay && <ConsultationOverlay onClose={() => setShowOverlay(false)} />}
    </div>
  );
};

export default Hero;
